export default __webpack_public_path__ + "static/wand-education_small-image_2-208ad7683789385496fda82eb98da9b6.webp";